import { render, staticRenderFns } from "./ShowMessage.vue?vue&type=template&id=84d81efa&"
import script from "./ShowMessage.vue?vue&type=script&lang=js&"
export * from "./ShowMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports